import React, { useRef } from 'react'
import classNames from 'classnames'
import { UploadIcon } from '../assetsComponents'

/**
 * Reusable file upload zone component
 * Handles drag-and-drop and click-to-upload functionality
 */
const FileUploadZone = ({
  onFilesSelected,
  accept = 'image/jpeg,image/png,application/pdf',
  multiple = true,
  disabled = false,
  dragActive = false,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  className = '',
  label = 'Upload Policy',
  helperText = 'Supported Format: PDF, JPG, PNG',
}) => {
  const inputRef = useRef(null)

  const handleButtonClick = () => {
    if (!disabled && inputRef.current) {
      inputRef.current.click()
    }
  }

  const handleChange = (e) => {
    if (e.target.files && e.target.files.length > 0 && onFilesSelected) {
      onFilesSelected(e.target.files)
    }
  }

  return (
    <div className={`mt-3 ${className}`}>
      {label && <label className='s7 mb-2'>{label}</label>}
      <form
        id='fileUploadForm'
        className={classNames(
          'upload-zone py-3 text-center position-relative cursor-pointer',
          {
            'drag-active': dragActive,
          },
        )}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onClick={handleButtonClick}>
        <input
          ref={inputRef}
          type='file'
          id='fileUploadInput'
          className='d-none'
          accept={accept}
          multiple={multiple}
          onChange={handleChange}
          disabled={disabled}
        />
        <div className='mb-3'>
          <UploadIcon />
        </div>
        <p className='s7 mb-2'>
          Choose a file <span className='opacity-50 cursor-pointer'>or</span>{' '}
          drag it here
        </p>
        {helperText && <div className='s9 opacity-50'>{helperText}</div>}
      </form>
    </div>
  )
}

export default FileUploadZone
